export default __webpack_public_path__ + "static/media/sc-selector.15a25cd5.png";